import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getOrderGeneratorsFieldsWorksQualityControls: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
	},
	getOrderGeneratorsFieldsWorksQualityControl: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
	},
	createOrderGeneratorsFieldsWorksQualityControl: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
	},
	putOrderGeneratorsFieldsWorksQualityControl: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].PUT_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
	},
	patchOrderGeneratorsFieldsWorksQualityControl: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
	},
	deleteOrderGeneratorsFieldsWorksQualityControl: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
	},
}
